import {AfterViewInit, Directive, ElementRef, HostListener, Input, NgModule, Renderer2} from '@angular/core';


@Directive({
	selector: '[libCalculateEllipsis]'
})
export class CalculateEllipsisDirective implements AfterViewInit {
	@Input()
	lines: string;

	@Input()
	lineHeight = 1.7;

	constructor(private element: ElementRef, private renderer: Renderer2) {
	}

	@HostListener('window:resize')
	onResize() {
		this.calculateEllipsis();
	}

	ngAfterViewInit(): void {
		(this.element.nativeElement as HTMLElement).style.webkitLineClamp = this.lines;
		this.calculateEllipsis();
	}

	calculateEllipsis() {
		// the paragraph contains entire text and is hidden
		const paragraph = (this.element.nativeElement as HTMLElement).children[0] as HTMLElement;
		paragraph.style.webkitLineClamp = this.lines;
		const withEllipsisEl = (this.element.nativeElement as HTMLElement).children[1] as HTMLElement;
		const style = window.getComputedStyle(this.element.nativeElement).getPropertyValue('font-size');
		const fontSize = parseFloat(style);

		paragraph.innerHTML = paragraph.innerHTML
			.split('<p>').join('')
			.split('</p>').join('<br>')
			.split('><').join('> <');

		// do not calculate ellipsis if the text does not overflow the paragraph
		if (!paragraph.innerHTML || paragraph.offsetHeight >= paragraph.scrollHeight) {
			withEllipsisEl.innerHTML = paragraph.innerHTML;
			((this.element.nativeElement as HTMLElement).children[2] as HTMLElement).classList.add('hidden');
			return;
		}

		const content = paragraph.innerHTML.split(' ');

		let shorterContent = '';

		/* attaching tags directly to withEllipsisEl.innerHTML one by one causes errors, because ending tags are added automatically*/
		let innerHTML = '';

		for (let i = 0; i < content.length; i++) {
			innerHTML = `${innerHTML} ${content[i]}`;
			withEllipsisEl.innerHTML = innerHTML;
			shorterContent = i > 1 ? `${shorterContent} ${content[i - 2]}` : '';
			if (withEllipsisEl.offsetHeight > +this.lines * this.lineHeight * fontSize) {
				innerHTML = shorterContent + ' ...';
				withEllipsisEl.innerHTML = innerHTML;
				this.btnAlign();
				break;
			}
		}
	}

	btnAlign() {
		const p1 = (this.element.nativeElement as HTMLElement).children[0];
		const p2 = (this.element.nativeElement as HTMLElement).children[1];
		const showMoreBtn = (this.element.nativeElement as HTMLElement).children[2];
		const showLessBtn = (this.element.nativeElement as HTMLElement).children[3];

		if (!p1 || !p2) { return; }
		this.renderer.appendChild(p2, showMoreBtn);
		this.renderer.appendChild(p1, showLessBtn);
	}
}

@NgModule({
	declarations: [CalculateEllipsisDirective],
	exports: [CalculateEllipsisDirective]
})
export class CalculateEllipsisDirectiveModule {}
